import { render, staticRenderFns } from "./RegistrationOverlayComponent.vue?vue&type=template&id=ad6e499e"
import script from "./RegistrationOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./RegistrationOverlayComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports